import { render, staticRenderFns } from "./SupplierSelection.vue?vue&type=template&id=9f0195a6&"
import script from "./SupplierSelection.vue?vue&type=script&lang=js&"
export * from "./SupplierSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports